var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgClock = function SvgClock(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01238 10.0059C5.64538 10.0059 5.29238 9.80389 5.11638 9.45289C4.86938 8.95989 5.07038 8.35989 5.56438 8.11089L7.00638 7.38989V5.01489C7.00638 4.46189 7.45338 4.01489 8.00638 4.01489C8.55938 4.01489 9.00638 4.46189 9.00638 5.01489V8.00689C9.00638 8.38589 8.79238 8.73189 8.45338 8.90189L6.45838 9.90089C6.31538 9.97189 6.16238 10.0059 6.01238 10.0059Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.004 3C5.245 3 3 5.245 3 8.005C3 10.764 5.245 13.009 8.004 13.009C10.764 13.009 13.009 10.764 13.009 8.005C13.009 5.245 10.764 3 8.004 3ZM8.004 15.009C4.142 15.009 1 11.867 1 8.005C1 4.143 4.142 1 8.004 1C11.866 1 15.009 4.143 15.009 8.005C15.009 11.867 11.866 15.009 8.004 15.009Z",
    fill: "currentColor"
  })));
};
export default SvgClock;